import { defineStore } from 'pinia';
import { login, userView, queryUserMenuList } from '@/api/login';
import { setToken, removeToken } from '@/utils/auth';
import defAva from '@/assets/images/avator.png';

export default defineStore(
  'user',
  {
    state: () => ({
      teamId: '',
      userInfo: {},
      menuRoutes: [], // 菜单
      isCollapse: false, // 菜单折叠开关
      roles: [],
      permissions: []
    }),
    actions: {
      // 登录
      login(data) {
        return new Promise((resolve, reject) => {
          login(data).then(res => {
            setToken(res.token)
            resolve(res)
          }).catch(error => {
            reject(error)
          })
        })
      },
      // 获取用户信息
      getUserInfo() {
        return new Promise((resolve, reject) => {
          userView().then(res => {
            this.teamId = res.userInfo.teamId;
            this.userInfo = {...res.userInfo, ...res.company};
            this.userInfo.headImg = res.userInfo.headImg || defAva;
            this.permissions = res.auth.resIds.map(ele => +ele);
            // 获取菜单
            queryUserMenuList().then(res => {
              this.menuRoutes = setMenuProps(res.menuList);
            });
            resolve(res)
          }).catch(error => {
            reject(error);
            this.logOut();
          })
        })
      },
      // 退出系统
      logOut() {
        return new Promise((resolve) => {
          this.userInfo = {};
          this.roles = [];
          this.permissions = [];
          removeToken();
          resolve();
        })
      }
    }
  }
)

function setMenuProps(list = [], res = []) {
  list.forEach(item => {
    if (item.list && item.list.length) {
      item.children = setMenuProps(item.list);
    }
    res.push({
      ...item,
      title: item.menuName,
      path: item.menuUrl || ''
    });
  });
  return res;
}
